import { useParams } from "react-router-dom";
import CargoGatepass from "./CargoGatepass/CargoGatepass";
import NormalGatepass from "./NormalGatepass/NormalGatepassForm";
import OffshoreGatepass from "./OffshoreGatepass/OffshoreGatepass";
import TruckGatepass from "./TruckGatepass/TruckGatepass";

const GatepassTypeRenderer = () => {
  const { type } = useParams();

  switch (type) {
    case "normal":
      return <NormalGatepass />;
    case "offshore":
      return <OffshoreGatepass />;
    case "truck":
      return <TruckGatepass />;
    case "cargo":
      return <CargoGatepass />;
    default:
      return <div>Unknown Gatepass Type</div>;
  }
};

export default GatepassTypeRenderer;
